var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 124,
    viewBox: "0 0 100 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_145)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.229126 100.723V111.249C-0.227731 114.738 1.15899 118.084 3.62627 120.551C6.09355 123.019 9.43951 124.405 12.9288 124.407H86.613C90.1018 124.404 93.447 123.017 95.9139 120.55C98.3809 118.083 99.7681 114.738 99.7709 111.249V100.723C99.7709 100.025 99.4936 99.3552 99.0001 98.8617C98.5066 98.3682 97.8372 98.0909 97.1393 98.0909C96.4414 98.0909 95.772 98.3682 95.2785 98.8617C94.785 99.3552 94.5077 100.025 94.5077 100.723V111.249C94.5063 113.342 93.6741 115.349 92.1939 116.83C90.7136 118.31 88.7064 119.142 86.613 119.144H12.9288C11.8917 119.145 10.8647 118.941 9.90636 118.545C8.94805 118.148 8.07733 117.567 7.34403 116.834C6.61073 116.1 6.02925 115.23 5.63287 114.271C5.23649 113.313 5.03299 112.286 5.03403 111.249V100.723C5.03403 100.025 4.75678 99.3552 4.26326 98.8617C3.76974 98.3682 3.10039 98.0909 2.40245 98.0909C1.70451 98.0909 1.03516 98.3682 0.541646 98.8617C0.0481294 99.3552 -0.229126 100.025 -0.229126 100.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1393 94.3699L25.3156 72.5462C24.8193 72.0669 24.1545 71.8016 23.4645 71.8076C22.7746 71.8136 22.1145 72.0904 21.6266 72.5783C21.1387 73.0662 20.8619 73.7262 20.8559 74.4162C20.8499 75.1062 21.1152 75.771 21.5946 76.2673L47.9103 102.583C48.1545 102.828 48.4445 103.022 48.7638 103.154C49.083 103.287 49.4253 103.355 49.7709 103.355C50.1165 103.355 50.4587 103.287 50.778 103.154C51.0972 103.022 51.3872 102.828 51.6314 102.583L77.9472 76.2673C78.4265 75.771 78.6918 75.1062 78.6858 74.4162C78.6798 73.7262 78.403 73.0662 77.9151 72.5783C77.4272 72.0904 76.7672 71.8136 76.0772 71.8076C75.3872 71.8016 74.7224 72.0669 74.2261 72.5462L52.4024 94.3699V5.9857C52.4024 5.28777 52.1252 4.61841 51.6317 4.1249C51.1382 3.63138 50.4688 3.35413 49.7709 3.35413C49.0729 3.35413 48.4036 3.63138 47.9101 4.1249C47.4165 4.61841 47.1393 5.28777 47.1393 5.9857V94.3699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4f31c7171fcd4a97acae72d397e3ce03.svg";
export { ForwardRef as ReactComponent };